var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"pt-3"},[_c('documents-grid',{attrs:{"resourceTxt":_vm.resource,"resource_id":_vm.resource_id}})],1):_c('loading')
}
var staticRenderFns = []

export { render, staticRenderFns }